import { createSlice } from '@reduxjs/toolkit'
import { AppThunk } from '../rootReducer'
import { IInstitution } from './interfaces'

export const initialState = {
  data: {} as IInstitution,
  loaded: false,
  error: false,
  testMode: false
}

const programSlice = createSlice({
  name: 'institution',
  initialState,
  reducers: {
    setInstitution(state, action) {
      state.data = action.payload
      state.loaded = true
    },
    loadingFailed(state, action) {
      state.loaded = false
      state.error = action.payload
      state.data = {} as IInstitution
    },
    toggleTestMode(state) {
      if (state.testMode !== undefined) {
        state.testMode = !state.testMode
      } else {
        state.testMode = true
      }
    },
  },
})

export default programSlice.reducer
export const { setInstitution, loadingFailed, toggleTestMode } = programSlice.actions

export const fetchInstitution = (): AppThunk => async (dispatch, getState) => {
  console.log('Fetching institution...')
  try {
    const { baseUrl } = getState().misc
    const response = await fetch(`${baseUrl}/api/institution`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      //@ts-ignore
      credentials: window._is_react_dev_server ? "include" : "same-origin",
    })
    const data = await response.json()
    return dispatch(setInstitution(data))
  } catch (error: unknown) {
    if (error instanceof Error) {
      return dispatch(loadingFailed(error.toString()))
    } else if (typeof error === 'string') {
      return dispatch(loadingFailed(error))
    }
  }
}
